import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { axiosInstance } from "..";
import toast from "react-hot-toast";
import messages from "../../assets/Local/Local";
import { getProjectTasks } from "./TaskSlice";
import { getProposalSummary } from "./ProposalSlice";

const initialState = {
  allProjects: [],
  allProjectsLookups: [],
  singleProject: null,
  totalRecords: 0,
  userTasks: [],
  userProjects: [],
  logs: [],
  excelFileURL: '', 
  projectReport:null
};

export const getAllProjects = createAsyncThunk(
  "projects/allProjects",
  async (data) => {
    return await axiosInstance
      .get("Projects/GetAll", { params: data })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(
          error.response.data.error.message
            ? error.response.data.error.message
            : "Something Wrong"
        );
        return error;
      });
  }
);

export const addProject = createAsyncThunk(
  "projects/addProject",
  async (data, { dispatch }) => {
    return await axiosInstance
      .post("Projects/AddProject", data)
      .then((response) => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(
          error.response.data.error.message
            ? error.response.data.error.message
            : "Something Wrong"
        );

        return error;
      });
  }
);


export const updateProject = createAsyncThunk(
  `projects/updateProject`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .put(`Projects/UpdateProject`, data)
      .then((response) => {
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const getSingleProject = createAsyncThunk(
  `projects/getSingleProject`,
  async (id) => {
    return await axiosInstance
      .get(`Projects/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);
export const getUserProjects = createAsyncThunk(
  `projects/getUserProjects`,
  async (data) => {
    return await axiosInstance
      .get(`Projects/TaskSummary`, { params: data })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const updateUserTask = createAsyncThunk(
  `projects/updateUserTask`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .put(`Projects/UpdateTask/${data.taskId}`, data)
      .then((response) => {
        dispatch(getUserTasksPerProject(data.projectId))
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);
export const getUserTasksPerProject = createAsyncThunk(
  `projects/getUserTasksPerProject`,
  async (id) => {
    return await axiosInstance
      .get(`Projects/projectTasks/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const updateProjectService = createAsyncThunk(
  `projects/updateProjectService`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .put(`Projects/UpdateProjectService`, data)
      .then((response) => {
        dispatch(getProjectTasks({ projectId: data.projectId }))
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const getLogs = createAsyncThunk(
  `projects/logs`,
  async (data) => {
    return await axiosInstance
      .get(`ActivityLogs/${data.title}/${data.id}`, { params: data })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);

export const updateProjectStatus = createAsyncThunk(
  `projects/updateProjectStatus`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .post(`Projects/UpdateProjectStatus`, data)
      .then((response) => {
        dispatch(getProposalSummary(data.projectId))

        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);


export const uploadTaskExcel = createAsyncThunk(
  `projects/Upload_TaskExcel`,
  async (data, { dispatch }) => {
    return await axiosInstance
      .post(`Projects/Upload_TaskExcel?ProjectServiceId=${data.ProjectServiceId}`, data)
      .then((response) => {
        dispatch(getProjectTasks({ projectId: data.projectId }));
        toast.success(messages[localStorage.getItem("lang")].shared.done);
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
);



export const getProjectsExcelFile = createAsyncThunk(
  "projects/getProjectsExcelFile",
  async (data) => {
    return await axiosInstance
      .get("Projects/Export", {
        responseType: 'blob',
        params: data
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));

        // إنشاء <a> للتحميل
        const link = document.createElement("a");
        link.href = url;

        // لو السيرفر بيرجع اسم الملف في الهيدر
        const disposition = response.headers["content-disposition"];
        let fileName = `Projects_Export_${new Date().toLocaleDateString()}.xlsx`;

        if (disposition && disposition.includes("filename=")) {
          fileName = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "")
            .trim();
        }

        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();

        // تنظيف
        link.remove();
        window.URL.revokeObjectURL(url);

        return response;
      })
      .catch((err) => {
        toast.error(err.response.data.error.message, {});

        return err;
      });
  }
);

export const ExportProjectTasks = createAsyncThunk(
  "projects/ExportProjectTasks",
  async (data) => {
    return await axiosInstance
      .get(`Projects/ExportProjectTasks?projectId=${data.projectId}`, {
        params: data,
        responseType: 'blob',
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement("a");
        link.href = url;
        const disposition = response.headers["content-disposition"];
        let fileName = `ProjectTasks_Export_${new Date().toLocaleDateString()}.xlsx`;

        if (disposition && disposition.includes("filename=")) {
          fileName = disposition
            .split("filename=")[1]
            .replace(/['"]/g, "")
            .trim();
        }
        link.setAttribute("download", fileName);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
        return response;
      })
      .catch((err) => {
        toast.error(err.response.data.error.message, {});
        return err;
      });
  }
);

export const reorderProjectTasks = createAsyncThunk(
  "projects/reorderProjectTasks",
  async (data, { dispatch }) => {
    return await axiosInstance
      .put(`Projects/ReorderTasks`, data)
      .then((response) => {
        dispatch(getProjectTasks({ projectId: data[0].projectId }))
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
)
export const getProjectReport = createAsyncThunk(
  "projects/getProjectReport",
  async (data, { dispatch }) => {
    return await axiosInstance
      .get(`Projects/ProjectReport?Page=1&PageSize=10`, { params: data })
      .then((response) => {
        // dispatch(getProjectTasks({ projectId: data[0].projectId }))
        return response;
      })
      .catch((error) => {
        toast.error(error.response.data.error.message);
        return error;
      });
  }
)


const ProjectSlice = createSlice({
  name: "projects",
  initialState,
  extraReducers: (builder) => {
    builder.addCase(getAllProjects.fulfilled, (state, action) => {
      state.loading = false;

      state.totalRecords = action.payload.data.totalRecords;
      state.allProjects = action.payload.data.data;
      state.allProjectsLookups = action.payload.data.data.map((item) => ({
        id: item.projectId,
        name_en: item.companyNameEn,
        name_ar: item.companyNameEn,
      }));
    });
    builder.addCase(getSingleProject.fulfilled, (state, action) => {
      state.singleProject = action.payload.data;
    });
    builder.addCase(getLogs.fulfilled, (state, action) => {
      state.logs = action.payload.data.data;
      state.totalRecords = action.payload.data.totalRecords
    });

    builder.addCase(getUserProjects.fulfilled, (state, action) => {
      state.userProjects = action.payload.data.data
      state.totalRecords = action.payload.data.totalRecords;
    });
    builder.addCase(getUserTasksPerProject.fulfilled, (state, action) => {
      state.userTasks = action.payload.data;
    });
    builder.addCase(getProjectsExcelFile.fulfilled, (state, action) => {


      state.excelFileURL = action.payload.data;
    });

    builder.addCase(getProjectReport.fulfilled, (state, action) => {
      state.projectReport = action.payload.data;
    });
  },
});

export const ProjectReducer = ProjectSlice.reducer;
